import React from 'react';
import classNames from 'classnames';
import styles from './Table.module.scss';

interface TableHeadProps {
  children: React.ReactNode;
  className?: string;
  align?: 'left' | 'center' | 'right';
}

export function TableHead({
  children,
  className,
  align = 'left',
}: TableHeadProps) {
  return (
    <div
      className={classNames(
        styles.tableHead,
        {
          [styles.alignCenter]: align === 'center',
          [styles.alignRight]: align === 'right',
        },
        className
      )}
    >
      {children}
    </div>
  );
}

export default TableHead;
